// extracted by mini-css-extract-plugin
export default {"root":"styles_root__WejAs","label":"styles_label__o9Oin","fieldRequired":"styles_fieldRequired__F8+g+"};